import React from 'react';

import {
	useIsObjectSidebarShown,
	useObjectSidebarActions,
	usePanel,
	useActiveActionInPanel,
} from '@confluence/object-sidebar-api/entry-points/useObjectSidebar';

export function useCreateObjectSidebarProp() {
	const isObjectSidebarShown = useIsObjectSidebarShown();
	const panel = usePanel();
	const activeActionInPanel = useActiveActionInPanel();
	const {
		changeHeaderElements,
		showObjectSidebar,
		hideObjectSidebar,
		hideObjectSidebarByPanelId,
		setActiveActionInPanel,
	} = useObjectSidebarActions();

	/**
	 * DON'T REMOVE useMemo here, otherwise it will cause very very serious performance issue
	 */
	return React.useMemo(() => {
		return {
			state: { isObjectSidebarShown, panel, activeActionInPanel },
			actions: {
				changeHeaderElements,
				showObjectSidebar,
				hideObjectSidebar,
				hideObjectSidebarByPanelId,
				setActiveActionInPanel,
			},
		};
	}, [
		isObjectSidebarShown,
		panel,
		activeActionInPanel,
		changeHeaderElements,
		showObjectSidebar,
		hideObjectSidebar,
		hideObjectSidebarByPanelId,
		setActiveActionInPanel,
	]);
}
